import React from 'react';
import { Link } from 'react-router-dom';
import {
  faLaptopCode,
  faWandMagicSparkles,
  faMobile,
} from '@fortawesome/free-solid-svg-icons';

import NavBar from '../NavBar';
import {
  MainBtn,
  SecondaryBtn,
  Section,
  MainTitle,
  MainTitleMid,
  Paragraf,
  FeaturesImgLeft,
} from '../Styled';
import UdviklingSection from './UdviklingSection';

import { SweetBox, SweetBoxInnerBig } from '../blocks/Sweetbox.styled';
import Slider from '../blocks/Slider';
import Footer from '../blocks/Footer';

import Curve from '../svgfiles/Curve';
import {
  WebHero,
  WebParaCtaUp,
  UpperSection,
  DownSection,
} from './Webudvikling.styled';
import { UpperCta, CtaLeft, CtaCon, Mockups } from '../blocks/CTAUp.styles';

import PLACEHOLDERIMG from '../images/soundlease-side.png';
import ImgPlaceholder from '../images/nye_designs_img.png';
import WEBCASES from '../images/webdesign-by-noaly.png';
import WEBAPPS from '../images/webapp_mocups.png';
import ROCKET from '../images/rakket_img.jpg';
import WebFaq from '../blocks/WebFaq';
import CTAUp from '../blocks/CTAUp';

const CARDS = [
  {
    id: 0,
    source: ImgPlaceholder,
    title: 'Vedligeholdelse',
    text: 'Hos Noaly tilbyder vi vedligeholdelse af din hjemmeside. Det kan være alt fra opdateringer til backups.',
  },
  {
    id: 1,
    source: ImgPlaceholder,
    title: 'PWA',
    text: 'Progressive Web Apps (PWA) er webapps, der bruger servicearbejdere, mm. i kombination med progressiv forbedring for at give brugerne en oplevelse på niveau med native apps.',
  },
  {
    id: 2,
    source: ImgPlaceholder,
    title: 'Responsivt',
    text: 'Vi sørger for din hjemmeside kan repræsentere din virksomhed lige godt på smartphones, tablets og desktops.',
  },
  {
    id: 3,
    source: ImgPlaceholder,
    title: 'Digital identitet',
    text: 'Ønsker du at starte dit eget business? Stil dig kraftfuldt ind i branchen med en hjemmeside der kan repræsentere dig bedst.',
  },
  {
    id: 4,
    source: ImgPlaceholder,
    title: 'SEO baseret',
    text: 'Vi sørger for din hjemmesides skelet bliver etableret på den mest brugervenlige måde, så Googles søgemaskine giver flere points til din hjemmeside.',
  },
];

const Webudvikling = () => {
  return (
    <div>
      <WebHero>
        <NavBar />
        <CTAUp
          title='Webudvikling'
          body='Noaly leverer webudviklingstjenester på ekspertniveau for at gøre din idé til en webbaseret løsning af høj kvalitet. Præcist som du havde forestillet dig.'
          photo={PLACEHOLDERIMG}
          alt='Soundlease WebApp'
          btn='Se cases'
          to='/cases'
        />
        <Curve />
      </WebHero>
      <UpperSection>
        <UdviklingSection
          lt1='Mobilvenligt Design'
          pa1='Passende til alle enheder i alle størrelser.'
          ic1={faMobile}
          lt2='Hastighedsoptimeret'
          pa2='Bedste funktioner med mindst brug af CPU.'
          ic2={faWandMagicSparkles}
          lt3='Effektiv'
          pa3='Gør det lettere for digselv og dine kunder.'
          ic3={faLaptopCode}
        />
        <UpperCta>
          <CtaLeft>
            <MainTitle>Webapp udvikling</MainTitle>
            <Paragraf>
              Uanset hvad dit webprojekt er. En applikation eller en kompleks platform. Med vores webudviklingstjenester vil du frigøre skyens fulde potentiale for at understøtte det.
            </Paragraf>
            <Link to='/kontakt'>
              <SecondaryBtn>Tag kontakt</SecondaryBtn>
            </Link>
          </CtaLeft>
          <CtaCon>
            <Mockups src={WEBAPPS} alt="Web Apps lavet af Noaly" />
          </CtaCon>
        </UpperCta>
      </UpperSection>

      <Section>
        <SweetBox>
          <SweetBoxInnerBig>
            <MainTitleMid>Leder du efter en Mobil App?</MainTitleMid>
            <WebParaCtaUp>
              Vi har erfaring med at designe og udvikle fuldendte løsninger med fokus på en fysisk enhed.
            </WebParaCtaUp>
            <Link to='/appudvikling'>
              <MainBtn>Læs mere</MainBtn>
            </Link>
          </SweetBoxInnerBig>
        </SweetBox>
      </Section>
      <DownSection
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <FeaturesImgLeft style={{ padding: '25px', margin: '0' }}>
          <div>
            <img src={ROCKET} alt="React" />
          </div>
          <div>
            <h1>Bedst mulige</h1>
            <h2>Brug af React</h2>
            <p>
              Vi udvikler vores Apps i React ved brug af jsx og SCSS. Vi laver
              alle vores apps som Progressive Web Apps, som giver din App
              muligheden for at kunne downloades både i App-store &
              GooglePlay-store for smartphones. <br /> <br />
              At kode en App i Javascript, kommer med flere fordele for vores
              kunder.
              <br /> <br />
              For eksempel har vi muligheden for at formatere Appen til
              bubble.io, hvor du derefter selv kan lave ændringer på farver med
              mere helt uden at kode.
            </p>
          </div>
        </FeaturesImgLeft>

        <Slider CARDS={CARDS} />

        <UpperCta style={{ margin: '0' }}>
          <CtaLeft>
            <MainTitle>Responsivt design</MainTitle>
            <Paragraf>
              Responsivt webdesign (RWD) er en webdesign-tilgang til at lave websider, der gengives godt på alle skærmstørrelser og opløsninger og samtidig sikre god brugervenlighed. Det er måden vi designer til et web med flere enheder.
            </Paragraf>
          </CtaLeft>
          <CtaCon>
            <Mockups src={WEBCASES} alt="Placeholder" />
          </CtaCon>
        </UpperCta>
      </DownSection>
      <WebFaq />

      <Footer />
    </div>
  );
};

export default Webudvikling;
